export const toBoolean = (value: string | number | boolean) =>
  // eslint-disable-next-line no-nested-ternary
  typeof value === 'string'
    ? value.toLowerCase() === 'true' || !['', '0', 'false'].includes(value.toLowerCase())
    : typeof value === 'number'
    ? value !== 0
    : value;
